export enum LogLevel {
    ERROR = "error",
    WARN = "warn",
    INFO = "info",
    TRACE = "trace",
}
